import { useState, useEffect } from 'react';
import { useSitemap } from 'wsm-common-data';
import { isBrowser } from 'ws-scripts/modules/environment';
import { usePostalCode } from './usePostalCode';
import { useShowMapEvent } from './useShowMapEvent';
import { useLocationCoordinates } from './useLocationCoordinates';
import { buildLocationTiles } from '../utils/buildLocationTiles';
import { useLocationsData } from './useLocationsData';

const DEFAULT_RANGE = 50;
const DEFAULT_EXCLUDE_BY_RANGE = true;

export const useLocationSearch = (paginationData) => {
	const [range, setRange] = useState(DEFAULT_RANGE);

	const postalCode = usePostalCode();
	const showMap = useShowMapEvent('showMap', false);
	const coordinates = useLocationCoordinates();

	const {
		locations: allLocationData,
		locationCount,
		error: errorMsg,
		isLoading,
		isReady,
		setSearchParams
	} = useLocationsData();

	// Trigger search when postal code or range changes
	useEffect(() => {
		if (!isBrowser) {
			return;
		}

		if (isReady && postalCode) {
			setSearchParams(postalCode, range, DEFAULT_EXCLUDE_BY_RANGE);
		}
	}, [postalCode, range, isReady, setSearchParams]);

	const sitemap = useSitemap();
	const rawLocationDetailPageUrl = sitemap.get('LOCATION_DETAILS');
	const locationDetailPagePart = (rawLocationDetailPageUrl || '').slice(
		0,
		-4
	);

	const noResults =
		locationCount === 0 || !allLocationData || allLocationData.length === 0;

	const tileData = buildLocationTiles(
		paginationData.paginatedData,
		locationDetailPagePart
	);

	return {
		isLoading,
		errorMsg,
		noResults,
		tileData,
		locationCount,
		allLocationData,
		showMap,
		coordinates,
		setRange,
		// Reset triggers for pagination
		resetTriggers: [postalCode, range, showMap]
	};
};
